<template>
  <div>
    <section class="main-banner-section">
      <content-creator
        :settings="getBlobContents('main-banner')"
        :permissions="contentCreatorPermissions"
        :is-visible="editContentCreator"
        :filestore="websitefilestore"
        name="main-banner"
        allowed-widgets="carousel,content-list,content-grid,vimeo-video"
        @updateBlob="(data) => saveBlob('main-banner', data)"
      />
    </section>
    <section class="cta-section upper-cta-section">
      <content-creator
        :settings="getBlobContents('content-blob-1-above')"
        :permissions="contentCreatorPermissions"
        :is-visible="editContentCreator"
        :filestore="websitefilestore"
        name="content-blob-1-above"
        allowed-widgets="advanced-wysiwyg-editor, wysiwyg-editor, grid, links, vimeo-video"
        class="home-intro-content"
        @updateBlob="(data) => saveBlob('content-blob-1-above', data)"
      />
      <content-creator
        :settings="getBlobContents('content-blob-1')"
        :permissions="contentCreatorPermissions"
        :is-visible="editContentCreator"
        :filestore="websitefilestore"
        name="content-blob-1"
        allowed-widgets="*"
        @updateBlob="(data) => saveBlob('content-blob-1', data)"
      />
    </section>

    <section class="cta-section middle-cta-section">
      <content-creator
        :settings="getBlobContents('home-product-carousel-header')"
        :permissions="contentCreatorPermissions"
        :is-visible="editContentCreator"
        :filestore="websitefilestore"
        name="home-product-carousel-header"
        allowed-widgets="advanced-wysiwyg-editor, wysiwyg-editor, grid, link-list, carousel, content-grid, content-list, vimeo-video"
        class="home-intro-content"
        @updateBlob="(data) => saveBlob('home-product-carousel-header', data)"
      />
    </section>
    <section class="cta-section lower-cta-section">
      <content-creator
        :settings="getBlobContents('latest-news')"
        :permissions="contentCreatorPermissions"
        :is-visible="editContentCreator"
        :filestore="websitefilestore"
        name="latest-news"
        @updateBlob="(data) => saveBlob('latest-news', data)"
      />
    </section>
    <section
      v-for="(_, index) in extraContentCreators"
      :key="index"
      :class="`cta-section cta-section-${index}`"
    >
      <content-creator
        :settings="getBlobContents(`home-page-extra-${index}`)"
        :permissions="contentCreatorPermissions"
        :is-visible="editContentCreator"
        :filestore="websitefilestore"
        :name="`home-page-extra-${index}`"
        @updateBlob="(data) => saveBlob(`home-page-extra-${index}`, data)"
      />
    </section>
  </div>
</template>

<script>
import contentCreatorMixin from 'src/app/content-creator-mixin'
import applogger from '@applogger'

const contentLoader = (store) => {
  applogger.debug('homepage asyncData starting')
  let blobsToLoad = {
    'main-banner': {},
    'latest-news': {},
    'main-grid': {},
    'content-blob-1-above': {},
    'home-product-carousel-header': {},
    'content-blob-1': {}
  }
  blobsToLoad = new Array(store.state.registry.getModuleSetting('homepage', 'extra-content-creators', 0)).fill(0).reduce((acc, cur, idx) => ({...acc, [`home-page-extra-${idx + 1}`]: {}}), blobsToLoad)
  let prefetchContent = []
  prefetchContent.push(store.dispatch('blob/loadgroup', {blobIDs: Object.keys(blobsToLoad), filestore: 'website', cacheOptions: { scope: 'global', ttl: 3600 * 12 }}))
  return Promise.all(prefetchContent)
    .then(() => {
      if (store.getters['blob/isHeader']('main-banner')) {
        store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: true })
      }
      applogger.debug('homepage asyncData Complete - website-client')
    })
}

export default {
  name: 'homepage',
  mixins: [
    contentCreatorMixin
  ],
  asyncData({ store, route }) {
    return contentLoader(store)
  },
  headData: true,
  computed: {
    extraContentCreators: function() {
      return new Array(this.$store.state.registry.getModuleSetting('homepage', 'extra-content-creators', 0)).fill(0).reduce((acc, cur, idx) => ({...acc, [idx + 1]: idx + 1}), {})
    }
  },
  created: function() {
    this.$eventHub.$on('loginComplete', this.reloadContent)
    this.$eventHub.$on('logoutComplete', this.reloadContent)
  },
  mounted() {
    if (this.$store.getters['blob/isHeader']('main-banner')) {
      this.$store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: true })
    }
  },
  methods: {
    reloadContent: function() {
      contentLoader(this.$store)
    },
    segmentation: function(tag) {
      if (this.$store.getters['user/isLoggedIn']) {
        if (this.$store.getters['user/checkPermissions']('vuejs edit menu')) {
          return true
        }
        else {
          let person = this.$store.state.user.Person
          return person.nid && person.field_x_person_specific_lists.some(x => x.value === tag)
        }
      }
    }
  }
}
</script>
